const getAudioDuration = (blob, cb) => {
  const audio = new Audio();

  audio.addEventListener("loadedmetadata", function() {
    cb(audio.duration.toFixed(0));
  });

  audio.src = URL.createObjectURL(blob);
};

export default getAudioDuration;
